import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ViewPrescriptionsComponent } from './view-prescriptions.component';
import { SharedModule } from '../../shared/shared.module';
import { MatListModule } from '@angular/material';

const routes: Routes = [
  { path: '', component: ViewPrescriptionsComponent },
];

@NgModule({
  declarations: [
    ViewPrescriptionsComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatListModule,
    RouterModule.forChild(routes)
  ],
  providers: [],
  entryComponents: [],
  bootstrap: [],
  exports: [RouterModule]
})
export class ViewPrescriptionsModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-prescriptions/view-prescriptions.module.ts